export default __webpack_public_path__ + "static/media/h_wdt_c_3_4.2cbc3bdd.mp3";